export default "__VITE_ASSET__Oh_7JQnd__"